/**
 * Sign In Prompt - Web Version
 * Redirects to the web app's sign-in page instead of showing inline prompt
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const SignInPrompt = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to sign-in page (only once on mount)
    navigate('/signin');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // ← Empty deps - only run once on mount

  return null;
};
